/**
 * @module Utilities/Strings
 * @desc Helpers funtions to format date
 */

export function formatDate(date: string): string {
  return date.substr(0, 10).split('-').reverse().join('/');
}

export function formatShortDate(date: string): string {
  return date.substr(5, 5).split('-').reverse().join('/');
}
